
export const SortBy = [
	{ value: 'LastEditedDESC', label: 'Recently updated' },
	{ value: 'CreatedDESC', label: 'Recently created' },
	{ value: 'NameASC', label: 'Business Name' },
	{ value: 'ContactASC', label: 'Contact Person' }
];